function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 6,
  fill: "#808080"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.53125 8L10.1406 6.39062L10.4688 6.0625C10.4896 6.04167 10.5 6.01562 10.5 5.98438C10.5 5.94271 10.4896 5.91146 10.4688 5.89062L10.1094 5.53125C10.0885 5.51042 10.0573 5.5 10.0156 5.5C9.98438 5.5 9.95833 5.51042 9.9375 5.53125L8 7.46875L6.0625 5.53125C6.04167 5.51042 6.01042 5.5 5.96875 5.5C5.9375 5.5 5.91146 5.51042 5.89062 5.53125L5.53125 5.89062C5.51042 5.91146 5.5 5.94271 5.5 5.98438C5.5 6.01562 5.51042 6.04167 5.53125 6.0625L7.46875 8L5.53125 9.9375C5.51042 9.95833 5.5 9.98958 5.5 10.0312C5.5 10.0625 5.51042 10.0885 5.53125 10.1094L5.89062 10.4688C5.91146 10.4896 5.9375 10.5 5.96875 10.5C6.01042 10.5 6.04167 10.4896 6.0625 10.4688L8 8.53125L9.9375 10.4688C9.95833 10.4896 9.98438 10.5 10.0156 10.5C10.0573 10.5 10.0885 10.4896 10.1094 10.4688L10.4688 10.1094C10.4896 10.0885 10.5 10.0625 10.5 10.0312C10.5 9.98958 10.4896 9.95833 10.4688 9.9375L8.53125 8Z",
  fill: "currentColor"
});

var SvgErase = function SvgErase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgErase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/erase.e3ae37c5.svg";
export { ForwardRef as ReactComponent };